import { NgModule } from "@angular/core";
import { Routes, RouterModule } from "@angular/router";
import { HomePageComponent } from "./home-page/home-page.component";
import { ToolbarComponent } from "./shared/components/toolbar/toolbar.component";
import { LandingPageComponent } from "./shared/components/landing-page/landing-page.component";
import { SysSettingsComponent } from "./shared/components/settings/sys-settings/sys-settings.component";
import { PageLayoutComponent } from "./shared/components/page-layout/page-layout.component";
import { DagaComponent } from "./pages/home/daga/daga.component";
import { SettlementComponent } from "./pages/transactions/settlement/settlement.component";
import {
  EligibleProfileGuard,
  LoginGuardForProfile,
} from "./core/guards/eligible-profile.guard";
import { PaymentGuard } from "./core/guards/payment/payment.guard";
import { UsersGuard } from "./core/guards/users/users.guard";
import { TransactionGuard } from "./core/guards/transactions/transaction.guard";
import { SettlementGuard } from "./core/guards/settlement/settlement.guard";
import { BusinessGuard } from "./core/guards/Business/business.guard";
import { HowToHomeComponent } from "./shared/components/how-to/how-to-home/how-to-home.component";
import { BusinessSetupComponent } from "./shared/components/how-to/business-setup/business-setup.component";
import { LinkSetupComponent } from "./shared/components/how-to/link-setup/link-setup.component";
import { UserSetupComponent } from "./shared/components/how-to/user-setup/user-setup.component";
import { TxnSetupComponent } from "./shared/components/how-to/txn-setup/txn-setup.component";
import { BankTransferComponent } from "./pages/transfer/bank-transfer/bank-transfer.component";
import { DashboardHomeComponent } from "./pages/dashboard/dashboard-home/dashboard-home.component";
import { DesignPageComponent } from "./pages/design-page/design-page.component";
import { PrivacyPolicyComponent } from "./pages/privacy-policy/privacy-policy.component";
import { ApiKeySetupComponent } from "./pages/api-key-setup/api-key-setup.component";

const routes: Routes = [
  { path: "", redirectTo: "/home", pathMatch: "full" },
  { path: "", loadChildren: "././pages/home/home.module#HomeModule" },
  { path: "new-design", component: DesignPageComponent },
  { path: "privacy-policy", component: PrivacyPolicyComponent },
  //  {path:'home', component: ToolbarComponent},
  // { path: "home", component: LandingPageComponent },
  { path: "login", redirectTo: "auth", pathMatch: "prefix" },

  { path: "auth", loadChildren: "././pages/login/login.module#LoginModule" },
  {
    path: "",
    component: PageLayoutComponent,
    children: [
      {
        path: "how-to",
        component: HowToHomeComponent,
        canActivate: [EligibleProfileGuard],
      },

      {
        path: "business-setup",
        component: BusinessSetupComponent,
        canActivate: [EligibleProfileGuard],
      },
      {
        path: "link-setup",
        component: LinkSetupComponent,
        canActivate: [EligibleProfileGuard],
      },
      {
        path: "user-setup",
        component: UserSetupComponent,
        canActivate: [EligibleProfileGuard],
      },
      {
        path: "txn-setup",
        component: TxnSetupComponent,
        canActivate: [EligibleProfileGuard],
      },

      {
        path: "dashboard",
        component: DashboardHomeComponent,
        canActivate: [EligibleProfileGuard],
      },
      {
        path: "settings",
        component: SysSettingsComponent,
        canActivate: [EligibleProfileGuard],
      },

      {
        path: "api-key",
        component: ApiKeySetupComponent,
        canActivate: [EligibleProfileGuard],
      },

      {
        path: "settlement",
        component: SettlementComponent,
        canActivate: [EligibleProfileGuard, SettlementGuard],
      },
      {
        path: "profile",
        loadChildren:
          "././pages/profile-settings/profile-settings.module#ProfileSettingsModule",
        canActivate: [LoginGuardForProfile],
      },
      {
        path: "transfer",
        loadChildren: "././pages/transfer/transfer.module#TransferModule",
        canActivate: [EligibleProfileGuard],
      },
      {
        path: "receive",
        loadChildren: "././pages/receive/receive.module#ReceiveModule",
        canActivate: [EligibleProfileGuard, PaymentGuard],
      },
      {
        path: "verification",
        loadChildren:
          "././pages/verification/verification.module#VerificationModule",
        canActivate: [EligibleProfileGuard],
      },
      {
        path: "userManagement",
        loadChildren: "././pages/users/users.module#UsersModule",
        canActivate: [EligibleProfileGuard, UsersGuard],
      },
      {
        path: "transactions",
        loadChildren:
          "././pages/transactions/transactions.module#TransactionsModule",
        canActivate: [EligibleProfileGuard, TransactionGuard],
      },
    ],
  },
];

@NgModule({
  imports: [RouterModule.forRoot(routes)],
  exports: [RouterModule],
})
export class AppRoutingModule {}
